import { render, staticRenderFns } from "./MsgElementText_Face.vue?vue&type=template&id=05818fd6&scoped=true"
import script from "./MsgElementText_Face.vue?vue&type=script&lang=js"
export * from "./MsgElementText_Face.vue?vue&type=script&lang=js"
import style0 from "./MsgElementText_Face.vue?vue&type=style&index=0&id=05818fd6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05818fd6",
  null
  
)

export default component.exports